import { useSelector } from 'react-redux';
import { identity } from 'lodash';
import { useMemo } from 'react';
export function useActiveLoaders({ filter = identity }) {
    const loaders = useSelector((state) => state.ui.activeLoaders);
    return useMemo(() => loaders.filter(filter), [loaders, filter]);
}
